import Map from 'ol/Map'
import View from 'ol/View'
import { defaults as defaultControls } from 'ol/control'

export function createMap({
  target,
  layers = [],
  viewOptions = {},
}) {
  return new Map({
    target,
    layers,
    view: new View({
      center: [
        0,
        0,
      ],
      zoom: 2,
      ...viewOptions,
    }),
    controls: defaultControls({ attribution: false }),
  })
}
